/*
 * Copyright (c) CIRROM 2022.
 */

/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsconstants = {
  aws_uk_s3_bucket: "secure-data-upload-uk-2",
  aws_uk_s3_bucket_region: "eu-west-2",
  aws_us_s3_bucket: "cirrom-data-uploads-storage-d3b72fbe203933-staging",
  aws_us_s3_bucket_region: "us-east-2",
  aws_eu_s3_bucket: "secure-data-upload-eu",
  aws_eu_s3_bucket_region: "eu-west-3",
};

export default awsconstants;
